import { render, staticRenderFns } from "./TreeselectWrapper.vue?vue&type=template&id=96373750&"
import script from "./TreeselectWrapper.vue?vue&type=script&lang=js&"
export * from "./TreeselectWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports